import { colors } from 'shared/styles/colors'
import styled from 'styled-components'
import { Typography } from '@material-ui/core'

export const Container = styled.div`
  display: flex;
  flex: 1;

  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  padding: 10px;

  div {
    text-align: center;
  }
`

export const Title = styled(Typography)`
  font-family: 'Inter', Roboto, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
  color: #6d787d;
`
export const ContainerIcon = styled.div`
  display: flex;
  width: 70px;
  height: 70px;
  border: 2px solid ${colors.blue};
  border-radius: 50%;
  align-items: center;
  justify-content: center;

  svg {
    width: 35px;
    height: 35px;
  }
`

export const Divider = styled.hr`
  margin-top: 16px;
  margin-bottom: 16px;
  border: 0.5px solid ${colors.lightGrey};
`

export const ContainerPayments = styled.div`
  display: flex;
  height: 100vh;
  background: ${colors.dashboard};
  flex-direction: column;
`

export const Body = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  overflow-y: hidden;
  overflow-x: hidden;
`

export const BreadCrumb = styled.div`
  display: flex;
  width: 100%;
  height: 41px;
  flex-direction: row;
  align-items: center;
  padding: 14px 30px;
  justify-content: space-between;
  background-color: ${colors.dashboard};
  z-index: 97;
`

export const PageTitle = styled.div`
  font-family: 'Roboto';
  font-style: italic;
  font-size: 16px;
  font-weight: 700;
  color: ${colors.grayDark};
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`

export const ContainerCards = styled.div`
  width: 100%;
  height: 100%;
  padding: 18px;
  overflow-y: scroll;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 6px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${colors.blue};
    border-radius: 70px;
  }
`
